module.exports = __webpack_public_path__ + "static/media/connetWalletSvg.faff4955.svg";